import { useQuery } from 'react-query';

import { getIsFeatureEnabled } from '../graphqls/kill-switch.2';

export const useKillSwitchQuery = (key_name: string) => {
  return useQuery(
    ['isFeatureEnabled', key_name],
    async () => {
      try {
        const { data } = await getIsFeatureEnabled({ key_name });
        return data.isFeatureEnabled;
      } catch {
        return false;
      }
    },
    {
      enabled: Boolean(key_name),
      retry: 5,
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchInterval: false,
      refetchOnWindowFocus: true,
    },
  );
};
